<script>
    import { onMount } from "svelte";
    import * as api from "../utiles/api";
    import * as Common from "../utiles/common.util";
    import * as store from "../stores/store";
    import { push } from "svelte-spa-router";
    import { Capacitor } from "@capacitor/core";
    import { PushNotifications } from "@capacitor/push-notifications";
    import { get } from "svelte/store";
    import { Preferences } from "@capacitor/preferences";
    import { theme } from "../stores/store";

    let id = "";
    let pw = "";
    let fcm_token = get(store.fcm_token);

    onMount(() => {
        // 로그인 상태 체크
        apiGetStatus();

        if (!window.location.href.includes("/Login")) {
            push("/Login");
        }
    });

    async function apiGetStatus() {
        if (Capacitor.isNativePlatform()) {
            const permStatus = await PushNotifications.requestPermissions();

            if (permStatus.receive !== "granted") {
                //alert("푸시 알림 권한이 거부되었습니다.");
                return;
            }
        }

        const token = await Common.getStoredToken();

        if (token) {
            if (location.href.includes("Login")) {
                push("/AsList");
            }
        } else {
            if (!location.href.includes("Login")) {
                push("/Login");
            }
        }
    }

    async function login() {
        if (Common.nullCheck(id, "id", "아이디")) return;
        if (Common.nullCheck(pw, "pw", "비밀번호")) return;

        const formData = {
            id,
            pw,
            role: "ADMIN",
            fcm_token,
        };

        const response = await api.post("/account/login", formData);

        if (response != null) {
            store.accountInfo.set(response.data);
            store.jwt_token.set(response.token.accessToken);
            store.refreshToken.set(response.token.refreshToken);

            await Preferences.set({
                key: "jwt_token",
                value: response.token.accessToken,
            });
            await Preferences.set({
                key: "refreshToken",
                value: response.token.refreshToken,
            });
            await Preferences.set({
                key: "accountInfo",
                value: JSON.stringify(response.data),
            });

            push("/AsList");
        }
    }
    function toggleTheme() {
        theme.update(t => t === 'light' ? 'dark' : 'light');
    }
</script>

<div class="login-container">
    <div class="login-card">
        <div class="login-header">
            <span class="role-badge">관리자 전용</span>
            <h1>A/S 이력관리시스템</h1>
            <p class="subtitle">서비스 관리를 위해 로그인해 주세요</p>
        </div>

        <div class="form-group">
            <label for="id">아이디</label>
            <input
                id="id"
                type="text"
                placeholder="아이디를 입력해주세요"
                bind:value={id}
                on:keypress={(e) => (e.key === "Enter" ? login() : "")}
            />
        </div>

        <div class="form-group">
            <label for="pw">비밀번호</label>
            <input
                id="pw"
                type="password"
                placeholder="비밀번호를 입력해주세요"
                maxlength="20"
                bind:value={pw}
                on:keypress={(e) => (e.key === "Enter" ? login() : "")}
            />
        </div>

        <button class="primary-btn" on:click={login}>로그인</button>

        <div class="footer-actions">
            <button class="ghost-btn" on:click={toggleTheme}>
                {#if $theme === "light"}
                    🌙 다크 모드로 보기
                {:else}
                    ☀️ 라이트 모드로 보기
                {/if}
            </button>
        </div>
    </div>
</div>

<style>
    .login-container {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 100vh;
        padding: 20px;
        background-color: var(--bg-primary);
        transition: background-color 0.3s ease;
    }

    .login-card {
        width: 100%;
        max-width: 420px;
        padding: 48px 40px;
        background-color: var(--bg-secondary);
        border-radius: var(--radius-md);
        box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
        height: auto;
        min-height: fit-content;
        transition:
            background-color 0.3s ease,
            transform 0.3s ease;
    }

    .login-header {
        text-align: center;
        margin-bottom: 40px;
    }

    .role-badge {
        display: inline-block;
        padding: 4px 12px;
        background-color: var(--color-primary-light);
        color: var(--color-primary);
        font-size: 12px;
        font-weight: 700;
        border-radius: 100px;
        margin-bottom: 12px;
    }

    h1 {
        font-size: 26px;
        font-weight: 800;
        color: var(--text-primary);
        letter-spacing: -1px;
        line-height: 1.2;
    }

    .subtitle {
        margin-top: 8px;
        font-size: 14px;
        color: var(--text-secondary);
    }

    .form-group {
        margin-bottom: 24px;
    }

    .form-group label {
        display: block;
        margin-bottom: 10px;
        font-size: 14px;
        font-weight: 700;
        color: var(--text-secondary);
    }

    input {
        width: 100%;
        padding: 16px;
        min-height: 56px;
        border: 1px solid var(--border-color);
        border-radius: 8px;
        background-color: var(--bg-primary);
        color: var(--text-primary);
        font-size: 16px;
        transition: all 0.2s ease;
    }

    input:focus {
        outline: none;
        border-color: var(--color-primary);
        box-shadow: 0 0 0 3px var(--color-primary-light);
    }

    .primary-btn {
        width: 100%;
        padding: 16px;
        background-color: var(--color-primary);
        color: #ffffff;
        border: none;
        border-radius: 8px;
        font-size: 16px;
        font-weight: 700;
        cursor: pointer;
        transition: all 0.2s ease;
        margin-top: 8px;
    }

    .primary-btn:hover {
        background-color: var(--color-primary-hover);
        transform: translateY(-1px);
    }

    .footer-actions {
        margin-top: 32px;
        text-align: center;
        border-top: 1px solid var(--border-color);
        padding-top: 24px;
    }

    .ghost-btn {
        background: none;
        border: 1px solid var(--border-color);
        padding: 8px 16px;
        border-radius: 20px;
        font-size: 12px;
        color: var(--text-secondary);
        cursor: pointer;
        transition: all 0.2s ease;
    }

    .ghost-btn:hover {
        background-color: var(--bg-primary);
        color: var(--text-primary);
        border-color: var(--text-secondary);
    }
</style>
